import { DatiPersonaliDTO } from "./dati-personaliDTO";
import { DatiFirmaVO } from "../vo/dati-firmaVO";
import { TipologiaDocumentoDTO } from "./tipologia-documentoDTO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { AutorizzazioneDTO } from "./autorizzazioneDTO";
import { AutoreDTO } from "./autoreDTO";
import { DatiVersionamentoDocumentoDTO } from "./dati-versionamento-documentoDTO";
import { TipoDocumentoDigitaleEnum } from "../enum/tipo-documento-digitale.enum";
import { DatiFirmaDTO } from "./dati-firmaDTO";
import { CampoSpecificoFascicoloDTO } from "./campo-specifico-fascicoloDTO";
import { LinguaDTO } from "./linguaDTO";

export class DocumentoDTO {
  idRepository: string;
  tipoDocumento: TipologiaDocumentoDTO = new TipologiaDocumentoDTO();
  nome: string;
  descrizione: string;
  hash: string;
  pubblicabile: Boolean;
  contieneDatiPersonali: Boolean;
  idAllegatoPadre: string;
  codice: string;
  primario: boolean = false;
  datiFirma: DatiFirmaDTO = new DatiFirmaDTO();
  preview: boolean;
  verificaFirma: boolean;
  codiceTipologia: string;
  dataManuale: string;
  dataInserimento: string;
  dataUltimaModifica: string;
  cartaceo: boolean;
  autore: AutoreDTO;
  firmatario: AutoreDTO[];
  tipoDocumentoDigitale: TipoDocumentoDigitaleEnum;
  datiPersonali: DatiPersonaliDTO = new DatiPersonaliDTO();
  tipoSupportoOriginale: TipoSupportoDocumentoEnum;
  datiVersionamento: DatiVersionamentoDocumentoDTO;
  collocazioneFisica: string;
  // tslint:disable-next-line:max-line-length
  riservato: boolean;
  campiSpecifici: CampoSpecificoFascicoloDTO[];
  esisteRichiestaFirma: boolean;
  statoRichiestaFirma: string;
  motivoFirma: string;
  dimensioni: number;
  lingue: LinguaDTO[];
}
